/// UUID フォーマット判定の単一ソース。
///
/// backend の `define_id!` マクロ (`apps/backend/crates/domain/src/core/ids.rs`) が
/// `Uuid::parse_str` で標準 36 文字ハイフン区切り UUID のみ受理するのに合わせ、
/// frontend もバージョン/バリアントを問わずに 36 文字ハイフン区切りだけを許容する。
///
/// domain の branded Id (`domain/value-objects/ids.ts`) と、 一覧条件復元の
/// `readUuidArray` (`shared/lib/list-view-state.ts`) が同じ意味論を共有するため、
/// ここに 1 箇所だけ定義する (issue #470 / 親 issue #430)。

/** 標準 36 文字ハイフン区切り UUID (RFC 9562)。バージョン/バリアントは問わない (backend `Uuid::parse_str` と同等)。 */
export const UUID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/**
 * `value` が標準 36 文字ハイフン区切り UUID 形式か判定する。
 *
 * 空文字は `false`。正規化はしない (大文字小文字はそのまま許容)。
 */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}
